export enum FormErrors {
  additionalInformation = 'Max. length: 1000 characters',
  confirmation = 'Please indicate that you are happy to submit',
}

export enum SubmissionSummaryFormFields {
  additionalInformation = 'additionalInformation',
  confirmation = 'confirmation',
}
